import Api from '../Api';

export const getNewOutwardNumber = () => async dispatch => {
  const { data } = await Api.get(`/store-outwards/newoutwardno`);
  dispatch({
    type: 'FETCH_NEW_OUTWARD_NUMBER',
    payload: data,
  });
};

export const clearStoreOutwardsofRpo = () => {
  return {
    type: 'CLEAR_NEW_OUTWARD_NUMBER',
  };
};

export const getStoreOutwards = query => async dispatch => {
  const { data } = await Api.get('/store-outwards', query);
  dispatch({
    type: 'FETCH_STORE_OUTWARDS',
    payload: data,
  });
};

export const clearStoreOutwards = () => {
  return {
    type: 'CLEAR_STORE_OUTWARDS',
  };
};

export const getStoreOutward = id => async dispatch => {
  const { data } = await Api.get(`/store-outwards/${id}`);
  dispatch({
    type: 'FETCH_STORE_OUTWARD',
    payload: data,
  });
};

export const clearStoreOutward = () => {
  return {
    type: 'CLEAR_STORE_OUTWARD',
  };
};

export const getOutwardReport = query => async dispatch => {
  const { data } = await Api.get(`/store-outwards/report`, query);
  dispatch({
    type: 'FETCH_OUTWARD_REPORT',
    payload: data,
  });
};

export const clearOutwardReport = () => {
  return {
    type: 'CLEAR_OUTWARD_REPORT',
  };
};

export const getCustomerIdsForOutwardReport = query => async dispatch => {
  const { data } = await Api.get(
    `/store-outwards/dropdowns/customerids`,
    query
  );
  dispatch({
    type: 'FETCH_CUSTOMER_IDS_FOR_OUTWARD_REPORT',
    payload: data,
  });
};

export const clearCustomerIdsForOutwardReport = () => {
  return {
    type: 'CLEAR_CUSTOMER_IDS_FOR_OUTWARD_REPORT',
  };
};

export const getJobchartIdsForOutwardReport = query => async dispatch => {
  const { data } = await Api.get(
    `/store-outwards/dropdowns/jobchartids`,
    query
  );
  dispatch({
    type: 'FETCH_JOBCHART_IDS_FOR_OUTWARD_REPORT',
    payload: data,
  });
};

export const clearJobchartIdsForOutwardReport = () => {
  return {
    type: 'CLEAR_JOBCHART_IDS_FOR_OUTWARD_REPORT',
  };
};

export const getProcessesForOutwardReport = query => async dispatch => {
  const { data } = await Api.get(`/store-outwards/dropdowns/processes`, query);
  dispatch({
    type: 'FETCH_PROCESSES_FOR_OUTWARD_REPORT',
    payload: data,
  });
};

export const clearProcessesForOutwardReport = () => {
  return {
    type: 'CLEAR_PROCESSES_FOR_OUTWARD_REPORT',
  };
};

export const getVendorIdsForOutwardReport = query => async dispatch => {
  const { data } = await Api.get(`/store-outwards/dropdowns/vendorids`, query);
  dispatch({
    type: 'FETCH_VENDOR_IDS_FOR_OUTWARD_REPORT',
    payload: data,
  });
};

export const clearVendorIdsForOutwardReport = () => {
  return {
    type: 'CLEAR_VENDOR_IDS_FOR_OUTWARD_REPORT',
  };
};

export const getRPOIdsForOutwardReport = query => async dispatch => {
  const { data } = await Api.get(`/store-outwards/dropdowns/rpoids`, query);
  dispatch({
    type: 'FETCH_RPO_IDS_FOR_OUTWARD_REPORT',
    payload: data,
  });
};

export const clearRPOIdsForOutwardReport = () => {
  return {
    type: 'CLEAR_RPO_IDS_FOR_OUTWARD_REPORT',
  };
};
